module.exports = __webpack_public_path__ + "img/GLT-LOGISTICS-(TRADEMARK-NEGATIVO).42923c73.png";